import { render, staticRenderFns } from "./MessageToThePeople.vue?vue&type=template&id=ea259b40"
import script from "./MessageToThePeople.vue?vue&type=script&lang=ts"
export * from "./MessageToThePeople.vue?vue&type=script&lang=ts"
import style0 from "./MessageToThePeople.vue?vue&type=style&index=0&id=ea259b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports